/**
 * Client-safe Stripe config. The publishable key is safe to ship to the browser.
 * Checkout runs on Stripe's hosted page, so no Stripe.js bundle is required.
 */
export const STRIPE_PUBLISHABLE_KEY =
  "pk_live_51TvRpUBSviAqCTVz6EOy0m7NSRDxNGZdSuTDfutJ4RxsK8MWENoC1zez4UIi6TOhepZBgvuCUI1gHdVvnfTdiAIh00pzGVc536";

export type PaymentEnv = "sandbox" | "live";

export function getPaymentEnvironment(): PaymentEnv {
  return STRIPE_PUBLISHABLE_KEY.startsWith("pk_test_") ? "sandbox" : "live";
}

export const PRICE_LOOKUP_KEYS = ["inquira_pro_monthly", "inquira_pro_yearly"] as const;
export type PriceLookupKey = (typeof PRICE_LOOKUP_KEYS)[number];